import { InputAdornment } from '@mui/material';

import { IconCloseMS, IconSearchMS } from '../../constants/icons';
import { ClearButton, StyledInputBase } from './styles';

interface SearchProps {
  placeholder?: string;
  width?: string | number;
  withoutBorder?: boolean;
  value: string;
  setSearchField: (value: string) => void;
  disabled?: boolean;
  maxLength?: number;
}

export function Search({
  placeholder = 'Pesquisar',
  width,
  value,
  setSearchField,
  withoutBorder = false,
  disabled = false,
  maxLength = 11,
}: SearchProps): JSX.Element {
  return (
    <StyledInputBase
      placeholder={placeholder}
      inputProps={{ 'aria-label': placeholder, maxLength }}
      type="search"
      disabled={disabled}
      value={value}
      startAdornment={
        <InputAdornment
          position="start"
          sx={(theme) => ({
            color: theme.palette.secondary.main,
          })}
        >
          {IconSearchMS}
        </InputAdornment>
      }
      endAdornment={
        value.length > 0 && (
          <InputAdornment position="end">
            <ClearButton
              aria-label="limpar busca"
              onClick={() => setSearchField('')}
            >
              {IconCloseMS}
            </ClearButton>
          </InputAdornment>
        )
      }
      onChange={(e) => setSearchField(e.target.value)}
      customWidth={width}
      withoutBorder={withoutBorder}
    />
  );
}
